import 'bootstrap/dist/css/bootstrap.css';
import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import fire from '../../config/Fire';
import CheckEmail from '../check-email/CheckEmail';
import ConfirmEmail from '../confirm-email/ConfirmEmail';
import { ExportData } from '../export-data/ExportData';
import { Home } from '../home/Home';
import PrivacyPolicy from '../privacy-policy/PrivacyPolicy';
import Login from '../login/Login';

class AppRouter extends Component {
  constructor() {
    super()
    this.state = ({
      userId: null,
    })
    this.authListener = this.authListener.bind(this)
  }

  componentDidMount() {
    this.authListener()
  }

  authListener() {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({ userId: user.uid })
        localStorage.setItem('user', user.uid)
      } else {
        this.setState({ userId: null })
        localStorage.removeItem('user')
      }
    })
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route exact path='/' render={() => <Home {...this.state} />} />
          <Route path="/login" component={() => <Login />} />
          <Route path="/check-email" component={() => <CheckEmail />} />
          <Route path="/confirm-email" component={() => <ConfirmEmail />} />
          <Route path="/privacy-policy" component={() => <PrivacyPolicy />} />
          <Route path="/export" component={() => <ExportData {...this.state} />} />
          <Route render={() => <h1>Page not found</h1>} />
        </Switch>
      </Router>
    )
  }
}

export default AppRouter



// WEBPACK FOOTER //
// ./src/components/app-router/AppRouter.js